<footer class="amt-footer">
    <div class="footer-main">
        <div class="footer-container">
            <div class="footer-grid">
                <!-- Company Info -->
                <div class="footer-col">
                    <div class="footer-brand">
                        <img src="assets/img/AMT.png" alt="Aathreya Machine Tools" class="brand-logo">
                    </div>
                    <p class="footer-desc">
                        A trusted name in Tool Room Machineries Sales & Service.
                        Precision-driven machine solutions that empower industries to perform at their best.
                    </p>
                    <div class="social-links">
                        <a href="#"><i class="fab fa-facebook-f"></i></a>
                        <a href="#"><i class="fab fa-instagram"></i></a>
                        <a href="#"><i class="fab fa-linkedin-in"></i></a>
                        <a href="#"><i class="fab fa-whatsapp"></i></a>
                    </div>
                </div>

                <!-- Quick Links -->
                <div class="footer-col">
                    <h4>Quick Links</h4>
                    <ul>
                        <li><a routerLink="/home"><i class="fas fa-chevron-right"></i> Home</a></li>
                        <li><a routerLink="/about"><i class="fas fa-chevron-right"></i> About Us</a></li>
                        <li><a routerLink="/products"><i class="fas fa-chevron-right"></i> Products</a></li>
                        <li><a routerLink="/contact"><i class="fas fa-chevron-right"></i> Contact</a></li>
                    </ul>
                </div>

                <!-- Our Services -->
                <div class="footer-col">
                    <h4>Our Services</h4>
                    <ul>
                        <li><a href="javascript:void(0)"><i class="fas fa-chevron-right"></i> Machinery Sales</a></li>
                        <li><a href="javascript:void(0)"><i class="fas fa-chevron-right"></i> Installation &
                                Commissioning</a></li>
                        <li><a href="javascript:void(0)"><i class="fas fa-chevron-right"></i> Preventive Maintenance</a>
                        </li>
                        <li><a href="javascript:void(0)"><i class="fas fa-chevron-right"></i> Breakdown Support</a></li>
                        <li><a href="javascript:void(0)"><i class="fas fa-chevron-right"></i> Spare Parts Supply</a>
                        </li>
                        <li><a href="javascript:void(0)"><i class="fas fa-chevron-right"></i> Machine Reconditioning</a>
                        </li>
                    </ul>
                </div>

                <!-- Contact Info -->
                <div class="footer-col">
                    <h4>Contact Us</h4>
                    <div class="contact-items">
                        <div class="contact-item">
                            <i class="fas fa-map-marker-alt"></i>
                            <div>
                                <strong>Chennai Office</strong>
                                <p>Plot No. 8, Dharmalingam Nagar,<br>Thiruneermalai Road, Chennai – 600 169</p>
                            </div>
                        </div>
                        <div class="contact-item">
                            <i class="fas fa-map-marker-alt"></i>
                            <div>
                                <strong>Hosur Office</strong>
                                <p>No. 5/10, Plot No. 11,<br>Bedarapallai Road, Hosur – 635 136</p>
                            </div>
                        </div>
                        <div class="contact-item">
                            <i class="fas fa-phone-alt"></i>
                            <div>
                                <a href="tel:+919036022687">+91 90360 22687</a><br>
                                <a href="tel:+919513266444">+91 95132 66444</a>
                            </div>
                        </div>
                        <div class="contact-item">
                            <i class="fas fa-envelope"></i>
                            <div>
                                <a
                                    href="mailto:manikandan@aathreyamachinetools.com">manikandan&#64;aathreyamachinetools.com</a><br>
                                <a href="mailto:aathreyamachinetools@gmail.com">aathreyamachinetools&#64;gmail.com</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Copyright -->
    <div class="footer-bottom">
        <div class="footer-container d-flex justify-content-center position-relative w-100"
            style="max-width: 100%; padding: 0 40px;">
            <p class="text-center m-0 w-100">&copy; 2026 Aathreya Machine Tools. All rights reserved.</p>
            <p class="position-absolute m-0" style="right: 40px;">Designed & Developed by <a
                    href="https://www.cktechsoln.in/" target="_blank"
                    class="text-decoration-none text-white position-relative" style="z-index: 1;"><strong>CKTech
                        Solution Pvt Ltd.</strong></a></p>
        </div>
    </div>
</footer>